<smart-cart-form-token-section [token]="usageToken"></smart-cart-form-token-section>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Terms & Conditions</pdq-heading>
        <span class="card__subtitle"
          >If enabled, customers will be required to accept your terms and conditions before they can checkout</span
        >
      </div>
      <div class="card__actions">
        <pdq-slide-toggle
          [defaultValue]="formGroup.controls.terms.controls.enabled.value"
          (onToggle)="formGroup.controls.terms.controls.enabled.setValue($event)"></pdq-slide-toggle>
      </div>
    </div>
    @if (formGroup.controls.terms.controls.enabled.value) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="field">
          <span class="field__label">Text body</span>
          <rich-textarea
            [initialContent]="formGroup.controls.terms.controls.text.value"
            (contentChange)="onTermsTextChange($event)"
            [enableLinkInsert]="true"
            placeholder="Type your terms & conditions here"></rich-textarea>
          <pdq-input-color
            [formControl]="formGroup.controls.terms.controls.textColor"
            label="Text Color"
            [clearable]="true"
            clearTooltip="Reset to the default colour"
            (cleared)="formGroup.controls.terms.controls.textColor.setValue('')"></pdq-input-color>
        </div>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Buttons</pdq-heading>
      </div>
      <div class="card__actions">
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="buttonsExpanded"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleButtons()"></pdq-button>
      </div>
    </div>
    @if (buttonsExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="button-section">
          <div class="button-section__header">
            <span class="button-section__title">Checkout Button</span>
            <pdq-slide-toggle
              [defaultValue]="formGroup.controls.checkoutButton.controls.enabled.value"
              (onToggle)="onCheckoutButtonToggle($event)"></pdq-slide-toggle>
          </div>
          <p class="button-section__subtitle">
            Displays a button that will take the customer to the checkout page.<br />
            The Checkout button and View Cart Button cannot both be disabled.
          </p>
          @if (formGroup.controls.checkoutButton.controls.enabled.value) {
            <div class="button-section__fields">
              <div class="field">
                <span class="field__label">Button Label</span>
                <pdq-input
                  [formControl]="formGroup.controls.checkoutButton.controls.label"
                  placeholder="Checkout →"></pdq-input>
              </div>
              <div class="subsection">
                <div class="subsection__header">
                  <span class="subsection__title">DESIGN</span>
                  <pdq-button
                    class="collapse-chevron"
                    [class.collapse-chevron--open]="checkoutDesignExpanded"
                    icon="arrow_down"
                    variant="ghost"
                    plain="true"
                    size="large"
                    iconColor="var(--on-surface-default)"
                    (onClick)="toggleCheckoutDesign()"></pdq-button>
                </div>
                @if (checkoutDesignExpanded) {
                  <div class="subsection__content">
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Background Color</span>
                        @if (checkoutDesign.backgroundColorOverridden()) {
                          <pdq-link
                            label="Reset to global color"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.checkoutButton.controls.design.controls.backgroundColor)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-color [formControl]="checkoutDesign.displayBackgroundColor"></pdq-input-color>
                    </div>
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Text Color</span>
                        @if (checkoutDesign.textColorOverridden()) {
                          <pdq-link
                            label="Reset to global color"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.checkoutButton.controls.design.controls.textColor)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-color [formControl]="checkoutDesign.displayTextColor"></pdq-input-color>
                    </div>
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Hover Color</span>
                        @if (checkoutDesign.hoverColorOverridden()) {
                          <pdq-link
                            label="Reset to global color"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.checkoutButton.controls.design.controls.hoverColor)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-color [formControl]="checkoutDesign.displayHoverColor"></pdq-input-color>
                    </div>
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Corner Radius</span>
                        @if (checkoutDesign.cornerRadiusOverridden()) {
                          <pdq-link
                            label="Reset to global number"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.checkoutButton.controls.design.controls.cornerRadius)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-arrows
                        [formControl]="checkoutDesign.displayCornerRadius"
                        [min]="0"
                        widthSize="fullwidth"></pdq-input-arrows>
                    </div>
                  </div>
                }
              </div>
              <div class="field">
                <span class="field__label">Loader Label</span>
                <pdq-input
                  [formControl]="formGroup.controls.checkoutButton.controls.loaderLabel"
                  placeholder="Checking Out..."></pdq-input>
                <span class="field__hint">The text that will be displayed while the customer is being redirected</span>
              </div>
              <div class="field">
                <span class="field__label">Routing</span>
                <pdq-dropdown
                  [formControl]="formGroup.controls.checkoutButton.controls.routing"
                  [options]="routingOptions"
                  fullWidth="true"></pdq-dropdown>
                <span class="field__hint">Where the checkout button will take the customer when they click it</span>
              </div>
              @if (formGroup.controls.checkoutButton.controls.routing.value === 'custom_url') {
                <div class="field">
                  <span class="field__label">Custom Checkout URL</span>
                  <pdq-input
                    [formControl]="formGroup.controls.checkoutButton.controls.customUrl"
                    placeholder="https://example.com/checkout"></pdq-input>
                </div>
              }
            </div>
          }
        </div>

        <div class="button-section">
          <div class="button-section__header">
            <span class="button-section__title">View Cart Button</span>
            <pdq-slide-toggle
              [defaultValue]="formGroup.controls.viewCartButton.controls.enabled.value"
              (onToggle)="onViewCartButtonToggle($event)"></pdq-slide-toggle>
          </div>
          <p class="button-section__subtitle">
            Displays a button that will take the customer to the cart page.<br />
            The Checkout button and View Cart Button cannot both be disabled.
          </p>
          @if (formGroup.controls.viewCartButton.controls.enabled.value) {
            <div class="button-section__fields">
              <div class="field">
                <span class="field__label">Button Label</span>
                <pdq-input
                  [formControl]="formGroup.controls.viewCartButton.controls.label"
                  placeholder="View Cart"></pdq-input>
              </div>
              <div class="subsection">
                <div class="subsection__header">
                  <span class="subsection__title">Design</span>
                  <pdq-button
                    class="collapse-chevron"
                    [class.collapse-chevron--open]="viewCartDesignExpanded"
                    icon="arrow_down"
                    variant="ghost"
                    plain="true"
                    size="large"
                    iconColor="var(--on-surface-default)"
                    (onClick)="toggleViewCartDesign()"></pdq-button>
                </div>
                @if (viewCartDesignExpanded) {
                  <div class="subsection__content">
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Background Color</span>
                        @if (viewCartDesign.backgroundColorOverridden()) {
                          <pdq-link
                            label="Reset to global color"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.viewCartButton.controls.design.controls.backgroundColor)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-color [formControl]="viewCartDesign.displayBackgroundColor"></pdq-input-color>
                    </div>
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Text Color</span>
                        @if (viewCartDesign.textColorOverridden()) {
                          <pdq-link
                            label="Reset to global color"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.viewCartButton.controls.design.controls.textColor)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-color [formControl]="viewCartDesign.displayTextColor"></pdq-input-color>
                    </div>
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Hover Color</span>
                        @if (viewCartDesign.hoverColorOverridden()) {
                          <pdq-link
                            label="Reset to global color"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.viewCartButton.controls.design.controls.hoverColor)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-color [formControl]="viewCartDesign.displayHoverColor"></pdq-input-color>
                    </div>
                    <div class="field">
                      <div class="field__label-row">
                        <span class="field__label">Corner Radius</span>
                        @if (viewCartDesign.cornerRadiusOverridden()) {
                          <pdq-link
                            label="Reset to global number"
                            size="small"
                            (onClick)="
                              resetToGlobal(formGroup.controls.viewCartButton.controls.design.controls.cornerRadius)
                            "></pdq-link>
                        }
                      </div>
                      <pdq-input-arrows
                        [formControl]="viewCartDesign.displayCornerRadius"
                        [min]="0"
                        widthSize="fullwidth"></pdq-input-arrows>
                    </div>
                  </div>
                }
              </div>
              <div class="field">
                <span class="field__label">Loader Label</span>
                <pdq-input
                  [formControl]="formGroup.controls.viewCartButton.controls.loaderLabel"
                  placeholder="Redirecting to cart..."></pdq-input>
                <span class="field__hint">The text that will be displayed while the customer is being redirected</span>
              </div>
            </div>
          }
        </div>

        <div class="button-section">
          <div class="button-section__header">
            <span class="button-section__title">Continue Shopping Button</span>
            <pdq-slide-toggle
              [defaultValue]="formGroup.controls.continueShoppingButton.controls.enabled.value"
              (onToggle)="
                formGroup.controls.continueShoppingButton.controls.enabled.setValue($event)
              "></pdq-slide-toggle>
          </div>
          @if (formGroup.controls.continueShoppingButton.controls.enabled.value) {
            <div class="button-section__fields">
              <div class="field">
                <span class="field__label">Button Label</span>
                <pdq-input
                  [formControl]="formGroup.controls.continueShoppingButton.controls.label"
                  placeholder="Continue Shopping"></pdq-input>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</pdq-card>

<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <div class="card__title-block">
        <pdq-heading element="h5">Checkout Methods</pdq-heading>
      </div>
      <div class="card__actions">
        <pdq-button
          class="collapse-chevron"
          [class.collapse-chevron--open]="checkoutMethodsExpanded"
          icon="arrow_down"
          variant="ghost"
          plain="true"
          size="large"
          iconColor="var(--on-surface-default)"
          (onClick)="toggleCheckoutMethods()"></pdq-button>
      </div>
    </div>
    @if (checkoutMethodsExpanded) {
      <pdq-divider></pdq-divider>
      <div class="card__content">
        <div class="button-section">
          <div class="button-section__header">
            <span class="button-section__title">Express Checkout</span>
            <pdq-slide-toggle
              [defaultValue]="formGroup.controls.checkoutMethods.controls.expressCheckout.value"
              (onToggle)="
                formGroup.controls.checkoutMethods.controls.expressCheckout.setValue($event)
              "></pdq-slide-toggle>
          </div>
          <p class="button-section__subtitle">Allow users to checkout fast using your express checkout methods.</p>
        </div>
      </div>
    }
  </div>
</pdq-card>

<smart-cart-form-custom-code
  [enabledControl]="formGroup.controls.customCode.controls.enabled"
  [codeControl]="formGroup.controls.customCode.controls.code"
  [defaultCode]="starterTemplate"
  [variables]="customCodeVariables"></smart-cart-form-custom-code>
